var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 690.67,
    height: 424,
    viewBox: "0 0 690.67 424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 318h518v-318h-518z"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m167.12 183.46h39.448v-48.029h-39.448z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 424)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.403 0 0 2.403 -363.73 -223.7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.36 143.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.475 0 5.726 3.523 5.726 6.557v0.93h-1.029c-3.132 0-8.466-0.489-8.466-4.209 0-1.663 1.273-3.278 3.769-3.278m4.648 11.255h1.029v0.587c0 3.279-2.105 4.404-4.65 4.404-2.104 0-4.012-0.783-5.186-1.419-1.224-0.538-2.153-0.343-2.741 0.832l-0.49 0.93c-0.587 1.125-0.391 2.104 0.784 2.74 1.615 0.832 4.453 2.055 8.171 2.055 6.46 0 10.326-3.621 10.326-9.933v-13.555c0-1.371-0.685-2.056-2.055-2.056h-1.664c-1.321 0-2.006 0.685-2.006 2.056v0.979c0 0.685 0.098 1.076 0.098 1.076h-0.098s-2.35-4.698-7.83-4.698c-4.551 0-8.27 2.936-8.27 7.487 0 7.291 9.004 8.515 14.582 8.515",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.03 162.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 1.321 0.685 2.056 2.006 2.056h1.909c1.321 0 2.006-0.735 2.006-2.056v-1.517c0-0.538-0.098-1.125-0.098-1.125h0.098c1.224 2.447 4.258 5.285 8.172 5.285 3.768 0 6.263-1.762 7.292-5.139h0.097c1.322 2.594 4.6 5.139 8.515 5.139 5.188 0 8.172-2.936 8.172-9.494v-13.995c0-1.37-0.733-2.055-2.055-2.055h-2.104c-1.37 0-2.056 0.685-2.056 2.055v12.821c0 2.838-0.538 4.991-3.425 4.991-4.209 0-6.362-4.306-6.362-8.661v-9.151c0-1.37-0.685-2.055-2.006-2.055h-2.153c-1.321 0-2.055 0.685-2.055 2.055v12.821c0 2.692-0.391 4.991-3.328 4.991-4.404 0-6.459-4.502-6.459-8.661v-9.151c0-1.37-0.686-2.055-2.007-2.055h-2.153c-1.321 0-2.006 0.685-2.006 2.055z",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(294.11 144.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.062 0 7.438 3.132 7.438 7.781 0 4.599-3.376 7.781-7.438 7.781s-7.39-3.182-7.39-7.781c0-4.649 3.328-7.781 7.39-7.781m0 20.846c7.585 0 13.751-5.431 13.751-13.065 0-7.683-6.166-13.066-13.751-13.066s-13.702 5.383-13.702 13.066c0 7.634 6.117 13.065 13.702 13.065",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.56 144.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c4.062 0 7.438 3.132 7.438 7.781 0 4.599-3.376 7.781-7.438 7.781s-7.39-3.182-7.39-7.781c0-4.649 3.328-7.781 7.39-7.781m0 20.846c7.585 0 13.751-5.431 13.751-13.065 0-7.683-6.166-13.066-13.751-13.066s-13.702 5.383-13.702 13.066c0 7.634 6.117 13.065 13.702 13.065",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(340.46 161.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.489 1.419 0.098 2.349 1.615 2.349h2.3c1.174 0 1.957-0.538 2.3-1.713l4.648-13.751c0.49-1.468 0.93-3.767 0.93-3.767h0.099s0.39 2.299 0.88 3.767l4.649 13.751c0.343 1.175 1.125 1.713 2.3 1.713h2.3c1.517 0 2.153-0.93 1.664-2.349l-7.537-20.944c-0.391-1.175-1.125-1.664-2.299-1.664h-3.915c-1.174 0-1.957 0.489-2.3 1.664z",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.12 135.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h15.433c13.263 0 24.014 10.752 24.014 24.014 0 13.263-10.751 24.015-24.014 24.015h-15.433v-12h15.433c6.636 0 12.015-5.379 12.015-12.015 0-6.635-5.379-12.015-12.015-12.015h-15.433z",
    fill: "#1b82e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.51 159.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.216-24.008h-15.093l12.217 24.008-12.217 24.014 0.014 7e-3h15.072z",
    fill: "#0e4366"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b7363356f53b98e4f992133f6af0e9d0.svg";
export { ForwardRef as ReactComponent };